<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>KPI审核</el-breadcrumb-item>
                        <el-breadcrumb-item>查看KPI</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="6">
                    <!-- KPI部门树 -->
                    <el-container >
                        <el-aside style="width:100%;">
                            <el-input size="small" style="margin-bottom:12px;margin-top:12px;"  placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                        
                            <el-tree class="filter-tree" :data="data" v-loading="loading" :props="defaultProps" :default-expand-all="true" node-key="id" @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                                    <!-- <span :class="node.disabled==1?'hidden':(isDelete?'':'hidden')" style="margin-left:10px;">
                                        <el-button
                                            type="text"
                                            size="mini"
                                            @click="() => remove(node, data)">
                                            删除
                                        </el-button>
                                    </span> -->
                                </span>
                            </el-tree>
                        </el-aside>
                    </el-container>
                </el-col>
                <el-col :span="17" style="float:right;margin-top:12px;" :class="isShowList?'show':'hidden'">
                     <!-- 搜索条件 -->
                    <el-row class="viewKPITitle">
                        <el-col :span="4">
                            <el-input size="small" placeholder="人员姓名" v-model="title"></el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button size="small" icon="el-icon-search" @click="SearchByName"></el-button>
                        </el-col>
                    </el-row>
                    <!-- 头部信息 -->
                    <div style="margin-top:20px;" v-for="item in AllKPIInfo" :key="item.sysUser.Id" > 
                        <div style="margin-top:20px;padding-top: 10px;padding-bottom: 15px;text-align:left;" class="viewKPITitle">
                            <el-row style="margin-top:10px;text-align:center;">{{item.sysUser.MainDeptsName}} KPI考核表</el-row>
                            <el-row style="margin-top:10px;">
                                <el-col :span="6">
                                    被考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.sysUser.TrueName}}</span>
                                </el-col>
                                <el-col :span="6">
                                    被考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.sysUser.Duty}}</span>
                                </el-col>
                                <el-col :span="6">
                                    被考核者工号：<span v-if="AllKPIInfo.length>0">{{item.sysUser.UserCode}}</span>
                                </el-col>
                                <el-col :span="6">
                                    考核周期：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].Period}}{{item.userKPI[0].PeriodType==0?'月':'季度'}}</span>
                                </el-col>
                            </el-row>
                            <el-row style="margin-top:10px;">
                                <el-col :span="6">
                                    考核者姓名：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadTrueName}}</span>
                                </el-col>
                                <el-col :span="6">
                                    考核者岗位：<span v-if="AllKPIInfo.length>0">{{item.userKPI[0].LeadDuty}}</span>
                                </el-col>
                            </el-row>
                        </div>

                        <!-- 考核列表信息  show-summary :summary-method="getSummaries"-->
                        <el-table border show-summary :summary-method="getSummaries" :data="item.userKPI" style="margin-top:20px;" v-loading="loading" size="small">
                            <el-table-column label="KPI类型">
                                <template slot-scope="scope">
                                    {{scope.row.KPIType == 0 ? "职能" : (scope.row.KPIType == 1 ? "业绩" : (scope.row.KPIType == 2 ? "自定义" : (scope.row.KPIType == 3 ? "其它" : (scope.row.KPIType == 4 ? "内部管理指标" : (scope.row.KPIType == 5 ? "客户指标" : (scope.row.KPIType == 6 ? "敬业度" : (scope.row.KPIType == 7 ? "重点项目" : "团队管理")))))))}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="KPI"  label="KPI名称"></el-table-column>
                            <el-table-column prop="KPIWeight" label="KPI权重"></el-table-column>
                            <el-table-column min-width="170" prop="Explain" label="指标说明"></el-table-column>
                            <el-table-column min-width="240" prop="Contents" label="考核细则"></el-table-column>
                            <el-table-column label="周期">
                                <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
                            </el-table-column>
                            <el-table-column min-width="170" prop="Execution" label="完成情况"></el-table-column>
                            <el-table-column prop="SelfScore" label="自评评分">
                                <template slot-scope="scope">
                                    {{scope.row.Status == 0 ?'':scope.row.SelfScore}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="LeadScore" label="直属领导评分">
                                <template slot-scope="scope">
                                    {{scope.row.LeadStatus == 0 ?'':scope.row.LeadScore}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    
                    <el-row >
                        <el-col :span="24">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageIndex"
                                :page-sizes="pageSizes"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalCount"
                                style="float:right"
                            ></el-pagination>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetTreeDeptsData,GetPageUserKPIByDeptId } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
    watch: {
        //树状结构搜索
       filterText(val) {
         this.$refs.tree.filter(val);
       }
    },
    data(){
        return{
            currentRole:{},//当前用户角色
            frameid:'',//部门id
            thisperiod:'',//周期
            kpitype:'',//类型
            years:'',//当前年
            loading:true,
            filterText: '',
            FrameClickID:'',//部门id
            data:[],//部门树状结构
            defaultProps: {
                children: 'nodes',
                label: 'text',
                disabled:'type'
            },
            title:'',//创建人姓名
            AllKPIInfo:[],//员工列表
            pageSizes: [10, 20, 50, 100, 200],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
            isShowList:false,
        }
    },
    created() {
        this.frameid=getUrlKey('frameid');
        this.thisperiod=getUrlKey('thisperiod');
        this.kpitype=getUrlKey('kpitype');
        this.years=getUrlKey('years');
        //获取当前用户角色
        this.getCurrentRole();
        //获取部门树状结构
        this.getTreeDeptsData();
    },
    methods:{
        //获取当前用户角色
        getCurrentRole:function(){
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));
        },
        //获取部门树状结构
        getTreeDeptsData:function(){
            GetTreeDeptsData(this.frameid,this.currentRole.Key).then(res=>{
                this.loading=false;
                this.data=JSON.parse(res);
            })
        },
        //搜索
        SearchByName:function(){
            this.GetPageUserKPIByDeptId();
        },
        //根据部门获取其下的员工和当月考核信息
        GetPageUserKPIByDeptId:function(){
            GetPageUserKPIByDeptId(this.thisperiod,this.FrameClickID,this.years,this.kpitype,this.title,this.pageIndex,this.pageSize).then(res=>{
                this.AllKPIInfo=res.List;
                this.loading=false;
                this.totalCount=res.TotalCount;
            });
        },
         //获取合计列
        getSummaries:function(param){
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                else if(index === 2){
                    //第七列 自评分数合计
                    var quanzhong=0;
                    param.data.forEach((column, index) => {
                        quanzhong+=column.KPIWeight;
                    })
                    sums[index]=quanzhong;
                }
                else if(index === 7){
                    //第七列 自评分数合计
                    var SelfScoreAll=0;
                    param.data.forEach((column, index) => {
                        SelfScoreAll+=column.SelfScore;
                    })
                    sums[index]=SelfScoreAll.toFixed(2);
                }
                else if(index===8){
                    //第八列 领导评分合计
                    var leadScoreAll=0;
                    param.data.forEach((column, index) => {
                        leadScoreAll+=column.LeadScore;
                    })
                    sums[index]=leadScoreAll.toFixed(2);
                }
                
            });

            return sums;
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.text.indexOf(value) !== -1;
        },
        //节点点击事件
        handleNodeClick(data){
            this.FrameClickID=data.FrameID;
            this.loading=true;
            this.isShowList=true;
            //获取当前部门点击id
            this.GetPageUserKPIByDeptId();
        },
        //分页条件搜索
        handleSizeChange(val) {
            this.pageSize = val;
            this.getAuditKPIList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getAuditKPIList();
        },
    }

}
</script>
<style lang="less" scoped>

</style>
